const DondeEstamos = () => {
  return (
    <p>
      <strong>Showroom:</strong> Virrey del pino 2720, Belgrano - Horario de
      lunes a viernes de 17 a 20hs. <strong>Cita Previa.</strong>
    </p>
  );
};

export default DondeEstamos;
